export default {
    general: {
        add:            'Dodaj',
        edit:           'Uredi',
        delete:         'Obriši',
        cancel:         'Odustani',
        save:           'Spremi',
        confirm:        'Potvrdi',
        confirm_action: 'Potvrdi radnju',
        sign_out:       'Odjava',
        more_info:      'Više informacija',
        name:           'Naziv',
        refresh:        'Osvježi',
        actions:        'Radnje',
        status:         'Status',
        details:        'Detalji',
        type:           'Tip',
        overview:       'Pregled',
        settings:       'Postavke',
    },
    brand: {
        product_name: 'NervusEye',
        product_line: 'MONITOR',
        vendor:       'by iT TEAM d.o.o.',
        tagline:      'Upravljanje mrežnim operacijama',
    },
    search: {
        input_placeholder:   'Pretraži uređaje, IP adrese, MAC, senzore, podmreže...',
        placeholder_short:   'Brza pretraga...',
        tooltip:             'Globalna pretraga (Cmd + K / Ctrl + K)',
        quick_navigation:    'Brza navigacija',
        category_all:        'Sve',
        category_devices:    'Uređaji',
        category_sensors:    'Senzori',
        category_hosts:      'IPAM Domaćini',
        category_subnets:    'Podmreže',
        category_navigation: 'Navigacija',
        no_results_title:    'Nema rezultata za',
        no_results_desc:     'Pokušajte pretražiti po nazivu uređaja, IP adresi, MAC adresi, portu ili CIDR-u podmreže.',
        hint_navigate:       'za kretanje',
        hint_open:           'za otvaranje',
    },
    sla: {
        title:                   'SLA, Dostupnost & Izvještaji neprekidnosti rada',
        subtitle:                'Ugovorno praćenje SLA pragova, postotak dostupnosti flote, MTTR/MTTF metrike i trajanje prekida rada.',
        period:                  'Razdoblje',
        target:                  'Ciljani SLA',
        print_pdf:               'Ispiši / PDF izvještaj',
        export_csv:              'Izvezi CSV',
        search_placeholder:      'Filtriraj po uređaju, IP-u, modelu...',
        fleet_availability:      'Dostupnost flote',
        compliance_rate:         'Stopa usklađenosti',
        compliant_devices:       'Usklađeni uređaji',
        breached_devices:        'Prekršeni pragovi',
        total_outages:           'Ukupno prekida',
        fleet_mttr:              'MTTR flote',
        devices_breakdown:       'SLA raščlamba po uređajima',
        devices_matching_filter: 'uređaja odgovara odabranom filtru',
        no_devices_found:        'Nije pronađen nijedan uređaj',
        try_changing_filter:     'Pokušajte promijeniti filtre pretrage ili odaberite drugo razdoblje.',
        col_device:              'Uređaj',
        col_availability:        'Dostupnost',
        col_status:              'SLA status',
        col_outages:             'Prekidi',
        col_downtime:            'Ukupno prekid',
        col_mttr:                'MTTR',
        col_mttf:                'MTTF',
        col_remaining:           'Preostalo dopušteno',
    },
    // Short labels for the navigation row; nav.* stays the full section name
    nav_short: {
        dashboard:     'Pregled',
        devices:       'Uređaji',
        topology:      'Topologija',
        ipam:          'IPAM',
        documentation: 'Dokumenti',
        security:      'Sigurnost',
        syslog:        'Syslog',
        events:        'Događaji',
        tools:         'Alati',
        sla:           'SLA',
        templates:     'Predlošci',
        users:         'Korisnici',
        settings:      'Postavke',
        about:         'O aplikaciji',
    },
    nav: {
        dashboard:      'Nadzorna ploča',
        devices:        'Uređaji i stablo',
        topology:       'Topologija mreže',
        ipam:           'IPAM & Inventar',
        documentation:  'Dokumentacija',
        security:       'Sigurnost portova & Rogue detekcija',
        syslog:         'Syslog & SNMP Trapovi',
        events:         'Događaji i ispadi',
        tools:          'Mrežni alati',
        sla:            'SLA Izvještaji',
        sensors:        'Senzori',
        administration: 'Administracija',
        templates:      'Predlošci',
        users:          'Korisnički računi',
        settings:       'Globalne postavke',
        changelog:      'Dnevnik promjena',
        about:          'O programu & Pomoć',
    },
    common: {
        cancel:   'Odustani',
        close:    'Zatvori',
        select:   'Označi',
        deselect: 'Odznači',
        clear:    'Očisti',
    },
    languages: {
        en:              'English',
        hr:              'Hrvatski',
        sl:              'Slovenščina',
        de:              'Deutsch',
        fr:              'Français',
        change_language: 'Promijeni jezik',
    },
    status: {
        up:           'Dostupno (UP)',
        down:         'Nedostupno (DOWN)',
        warning:      'Upozorenje (WARN)',
        acknowledged: 'Potvrđeno',
        paused:       'Pauzirano',
        unknown:      'Nepoznato',
    },
    dashboard: {
        title:                'Operativna nadzorna ploča',
        subtitle:             'Mrežna telemetrija u realnom vremenu i zdravlje infrastrukture',
        total_devices:        'Ukupno uređaja',
        online_devices:       'Dostupni uređaji',
        warning_devices:      'Upozorenje / Degradirano',
        offline_devices:      'Nedostupno / Kritično',
        total_sensors:        'Aktivni senzori',
        network_health:       'Zdravlje mreže',
        all_systems_ok:       'Svi nadzirani uređaji i senzori rade uredno.',
        active_alerts:        'Aktivni alarmi i prekidi',
        active_alerts_desc:   'Uređaji i senzori koji zahtijevaju pažnju',
        recent_devices:       'Nadzirani mrežni uređaji',
        explore_tree:         'Otvori stablo uređaja',
        inspect:              'Pregledaj',
        auto_refresh:         'Automatsko osvježavanje',
        arrange_graphs:       'Uredi / Posloži grafove',
        done_arranging:       'Završi slaganje',
        arrange_hint:         'Način slaganja: Dodajte više telemetrijskih grafova, povucite kartice mišem ili koristite strelice za redoslijed i širinu stupaca.',
        grid_cols:            'Stupci:',
        save_layout:          'Spremi raspored',
        select_sensor_to_add: 'Odaberite senzor za prikaz u Live telemetriji...',
        add_graph:            'Dodaj graf',
        layout_saved:         'Raspored telemetrijskih grafova je spremljen',
        pause_sensor:         'Pauziraj senzor',
        top_metrics_title:    'Performanse i Top Uređaji',
        top_metrics_subtitle: 'Uvidi u stvarnom vremenu po potrošnji resursa, prometu i stabilnosti',
        widgets_active:       'aktivno',
        top_cpu:              'Top CPU opterećenje',
        top_cpu_desc:         'Uređaji s najvišim postotkom iskorištenosti procesora',
        top_ram:              'Top RAM potrošnja',
        top_ram_desc:         'Uređaji s najvišim postotkom i volumenom radne memorije',
        top_uptime:           'Dostupnost & Uptime',
        longest_uptime:       'Najdulji rad (Stabilnost)',
        recently_rebooted:    'Nedavno ponovno pokrenuti',
        top_ping:             'Top Latencija / Ping',
        top_ping_desc:        'Uređaji i servisi s najvišim mrežnim odzivom (RTT)',
        top_traffic:          'Top Mrežni promet',
        top_port_errors:      'Greške na portovima & Buffer dropovi',
        no_port_errors:       'Nema zabilježenih grešaka na portovima',
        top_bgp:              'BGP sesije',
        top_temperature:      'Top Temperatura & Hardver',
        top_storage:          'Top Pohrana / Disk',
        view_mode_grid:       'Mreža',
        view_mode_tabs:       'Kartice',
        customize_widgets:    'Prilagodi widgete',
        hosts_ranked:         'rangiranih uređaja',
        no_data:              'Nema podataka',
    },
    tree: {
        search_placeholder: 'Pretraži uređaje, IP, senzore...',
        filter_all:         'Sve',
        total_items:        'stavki',
        no_nodes_found:     'Nema rezultata za zadani kriterij',
        add_group:          'Dodaj grupu',
        add_folder:         'Dodaj mapu',
        add_device:         'Dodaj uređaj',
        add_sensor:         'Dodaj senzor',
        root_title:         'Infrastrukturno stablo',
        devices_selected:   '{count} označenih',
        drag_to_folder:     'Povucite u mapu za premještanje',
        devices_moved:      'Uspješno premješteno {count} uređaja u {target}',
        move_failed:        'Neuspješno premještanje uređaja',
        back_to_tree:       'Natrag na stablo',
    },
    devices: {
        title:                'Preglednik uređaja',
        add_device:           'Dodaj uređaj',
        edit_device:          'Uredi uređaj',
        delete_device:        'Obriši uređaj',
        confirm_delete:       'Jeste li sigurni da želite obrisati ovaj uređaj i sve njegove senzore?',
        name:                 'Naziv uređaja',
        name_placeholder:     'npr. Core-Switch-01',
        hostname_ip:          'Hostname / IP adresa',
        polling_interval:     'Interval ispitivanja (s)',
        snmp_enabled:         'Omogući SNMP',
        snmp_enabled_hint:    'Ispitivanje MIB metrike i automatska detekcija sučelja',
        snmp_version:         'SNMP verzija',
        snmp_port:            'SNMP port',
        snmp_community:       'Community string',
        poll_now:             'Ispitaj odmah',
        polling_started:      'Pokrenuto ručno ispitivanje',
        snmp_walk:            'SNMP Walk',
        snmp_walk_title:      'SNMP Walk dijagnostika',
        run_walk:             'Pokreni Walk',
        walking_mibs:         'Pretraživanje OID stabla...',
        no_walk_results:      'Nema vraćenih OID rezultata',
        device_details:       'Detalji uređaja',
        device_sensors:       'Konfigurirani senzori',
        sensors_count:        'Senzora',
        vendor:               'Proizvođač',
        model:                'Model',
        last_polled:          'Zadnje ispitano',
        no_devices_in_folder: 'Nema uređaja u ovoj mapi',
        select_node_hint:     'Odaberite grupu, mapu ili uređaj iz stabla na lijevoj strani za pregled detalja.',
    },
    discovery: {
        title:               'Otkrivanje sučelja i Autodiscovery',
        scan_interfaces:     'Skeniraj sučelja',
        run_autodiscovery:   'Pokreni puno automatsko otkrivanje',
        select_all:          'Označi sve',
        deselect_all:        'Odznači sve',
        add_selected:        'Dodaj označeno kao senzore',
        scanning_hint:       'Ispitivanje SNMP ifTable / ifXTable...',
        no_interfaces:       'Nisu pronađena sučelja. Provjerite odgovara li SNMP na uređaju.',
        description:         'Opis / Alias',
        speed:               'Brzina',
        discover_interfaces: 'Otkrij sučelja',
        group_by_type:       'Grupiraj uređaje u foldere po tipu uređaja',
        folders_preview:     'Mape koje će se popuniti / kreirati:',
    },
    sensors: {
        add_sensor:          'Dodaj senzor',
        edit_sensor:         'Uredi senzor',
        edit_sensor_title:   'Postavke senzora',
        type:                'Tip senzora',
        name:                'Naziv senzora',
        name_placeholder:    'npr. Ping Latencija',
        interval:            'Interval (s)',
        enabled:             'Senzor aktivan / uključen',
        enabled_hint:        'Kada je isključeno, poller privremeno pauzira ispitivanje senzora',
        oid:                 'SNMP OID',
        interface_index:     'Indeks sučelja',
        last_reading:        'Zadnje očitanje',
        last_checked:        'Zadnja provjera',
        confirm_delete:      'Jeste li sigurni da želite obrisati ovaj senzor?',
        no_sensors_assigned: 'Ovaj uređaj još nema dodijeljenih senzora',
        add_sensor_success:  'Senzor uspješno stvoren',
        add_sensor_error:    'Greška kod stvaranja senzora',
    },
    metrics: {
        more_ranges:   'Više vremenskih raspona',
        custom_range:  'Prilagođeni raspon',
        range_from:    'Od',
        range_to:      'Do',
        range_invalid: 'Početak mora biti prije kraja',
        apply:         'Primijeni',
        title:      'Telemetrija u realnom vremenu',
        current:    'Trenutno',
        avg:        'Prosjek',
        min:        'Min',
        max:        'Maks',
        p95:        '95. percentil',
        p95_hint:   '95. percentil 5-minutnih uzoraka u odabranom razdoblju, kao za izvještaje o prometu',
        no_data:    'Nema dostupnih očitanja za odabrano razdoblje',
    },
    templates: {
        title:                'SNMP predlošci i MIB-ovi',
        subtitle:             'Predlošci performansi uređaja i standardni hardverski profili',
        add_template:         'Dodaj predložak',
        edit_template:        'Uredi predložak',
        import_template:      'Uvezi predloške',
        import_template_hint: 'Zalijepite JSON strukturu za paketni uvoz predložaka.',
        import_mib:           'Uvezi MIB',
        import_mib_hint:      'Učitajte RFC ili proizvođačku MIB datoteku za popunjavanje OID kataloga.',
        export_all:           'Izvezi sve (JSON)',
        export:               'Izvezi',
        search_placeholder:   'Pretraži predloške po nazivu, proizvođaču...',
        templates_count:      'predložaka',
        no_templates_found:   'Nema pronađenih SNMP predložaka',
        template_oids:        'Konfigurirani OID-ovi predloška',
        add_oid:              'Dodaj OID',
        no_oids_added:        'U ovom predlošku još nema definiranih OID-ova.',
        expand_all:           'Proširi sve',
        collapse_all:         'Sažmi sve',
        what_oid_does:        'Što OID radi (Funkcionalnost)',
        metric_name:          'Naziv metrike',
        copy_oid:             'Kopiraj OID',
        filter_metrics:       'Filtriraj metrike u predlošku...',
    },
    users: {
        title:            'Korisnički računi',
        subtitle:         'Upravljanje pristupom operatera i ulogama',
        add_user:         'Dodaj korisnika',
        edit_user:        'Uredi korisnika',
        accounts:         'Registrirani računi',
        username:         'Korisničko ime',
        role:             'Uloga',
        password:         'Lozinka',
        change_password:  'Promijeni lozinku',
        old_password:     'Trenutna lozinka',
        new_password:     'Nova lozinka',
        confirm_password: 'Potvrdi novu lozinku',
        no_users_found:   'Nema pronađenih korisničkih računa',
    },
    settings: {
        title:                 'Sistemske postavke',
        subtitle:              'Globalna konfiguracija, revizijski zapisi i sigurnosne kopije baze',
        general_tab:           'Općenito',
        general_preferences:   'Opće postavke',
        appearance:            'Izgled',
        appearance_info:       'Tema boja za ovaj preglednik. Stranice, izbornici i kartice ostaju isti; mijenjaju se samo boje, okviri i font.',
        theme_company:         'Tvrtka',
        theme_company_desc:    'NervusEye boje: siva i narančasta',
        theme_classic:         'Klasična',
        theme_classic_desc:    'Izgled prvog ZeroNMS-a: tamnosiva, slate i plava',
        root_node_name:        'Naziv korijenskog čvora',
        default_traffic_unit:  'Zadana jedinica mrežnog prometa',
        autodiscover_interval:  'Interval autodiscoveryja',
        autodiscover_hint:      'Koliko često se svaki SNMP uređaj ponovno pretražuje za novim portovima, BGP peerovima, PPPoE i hardverskim senzorima. Senzori koje obrišete ne dodaju se ponovno.',
        autodiscover_off:       'Isključeno',
        autodiscover_hourly:    'Svaki sat',
        autodiscover_every:     'Svakih {n} h',
        audit_logs:            'Revizijski zapisi (Audit)',
        timestamp:             'Vrijeme',
        action:                'Izvedena radnja',
        backup_recovery:       'Sigurnosne kopije i oporavak',
        console_tab:           'Aplikacije konzole',
        console_downloads:     'Preuzimanje konzole',
        console_info:          'Izvorna desktop aplikacija koja se istovremeno spaja na više NervusEye MONITOR servera i prikazuje stabla uređaja, alarme i povijest senzora.',
        console_req_macos:     'macOS 14 Sonoma ili noviji, Apple silicon i Intel',
        console_req_windows:   'Windows 10 (1809) ili noviji, 64-bitni',
        console_req_android:   'Android 10 ili noviji',
        console_ios_note:      'iPhone i iPad: konzola se distribuira preko TestFlighta; zatraži pozivnicu od administratora.',
        console_build:         'Build',
        console_size:          'Veličina',
        console_published:     'Objavljeno',
        console_download:      'Preuzmi {file}',
        console_unavailable:   'Još nije dostupno',
        console_not_published: 'Na ovaj server još nije objavljena instalacija.',
        console_loading:       'Učitavanje...',
        console_connect:       'Spajanje na ovaj server',
        console_server_address:'Adresa servera',
        console_step_install:  'Instaliraj konzolu i pokreni je.',
        console_step_add:      'Odaberi Add Server i zalijepi gornju adresu servera.',
        console_step_login:    'Prijavi se svojim NervusEye MONITOR korisničkim imenom i lozinkom.',
        run_backup:            'Pokreni sigurnosnu kopiju',
        restore:               'Vrati kopiju',
        notifications_tab:     'Alarmi i obavijesti',
        notifications_title:   'Kanali za alarme i obavijesti',
        telegram_title:        'Telegram Bot za alarme',
        telegram_desc:         'Šaljite trenutne push notifikacije u privatni chat ili IT grupu na Telegramu.',
        telegram_enable:       'Omogući Telegram alarme',
        telegram_bot_token:    'Telegram Bot Token',
        telegram_token_help:   "Preuzmite od {'@'}BotFather na Telegramu (npr. 123456789:ABCdefGhI...)",
        telegram_chat_id:      'Telegram Chat ID',
        telegram_chat_help:    'ID chata ili grupe (npr. -100123456789 za grupu)',
        telegram_test_btn:     'Pošalji testni Telegram alarm',
        webhook_title:         'Webhook integracija',
        webhook_desc:          'Šaljite JSON alarme na Discord, Slack, Microsoft Teams ili vlastiti HTTP endpoint.',
        webhook_enable:        'Omogući Webhook alarme',
        webhook_url:           'Webhook URL adresa',
        webhook_url_help:      'Incoming webhook URL (npr. https://discord.com/api/webhooks/... ili Slack webhook)',
        webhook_type:          'Vrsta Webhook servisa',
        webhook_test_btn:      'Pošalji testni Webhook alarm',
        email_title:           'E-mail (SMTP) obavijesti',
        email_desc:            'Šaljite oblikovane HTML poruke o alarmima sa statusnim oznakama u boji i detaljima uređaja.',
        email_enable:          'Omogući E-mail alarme',
        smtp_host:             'SMTP poslužitelj',
        smtp_port:             'SMTP port',
        smtp_username:         'Korisničko ime (Username)',
        smtp_password:         'Lozinka (Password)',
        smtp_from:             'Adresa pošiljatelja (From)',
        smtp_to:               'Adrese primatelja (To, zarezom odvojene)',
        smtp_tls:              'Koristi TLS / STARTTLS enkripciju',
        email_test_btn:        'Pošalji testni E-mail',
        trigger_rules_title:   'Pravila okidanja alarma i zaštita od titranja',
        flapping_protection:   'Zaštita od titranja (uzastopni neuspjesi)',
        flapping_help:         'Broj uzastopnih neuspješnih ciklusa provjere prije slanja alarma za uklanjanje kratkotrajnih smetnji.',
        alert_cooldown:        'Odgoda ponavljanja alarma (Cooldown)',
        cooldown_help:         'Vrijeme čekanja u minutama prije ponavljanja obavijesti za aktivni ispad (0 = samo pri promjeni stanja).',
        notify_down:           'Obavijesti o ispadu / DOWN',
        notify_down_help:      'Pošalji alarm čim uređaj ili senzor prijeđe u status DOWN',
        notify_warning:        'Obavijesti o upozorenju / WARNING',
        notify_warning_help:   'Pošalji alarm kada senzor prekorači granicu upozorenja',
        notify_recovery:       'Obavijesti o oporavku / RECOVERY',
        notify_recovery_help:  'Pošalji poruku oporavka kada se uređaj ili senzor vrati u normalan rad',
    },
    events: {
        title:            'Povijest ispada i događaja',
        subtitle:         'Kronološki zapis mrežnih ispada, upozorenja i oporavka sustava',
        tab:              'Događaji i ispadi',
        total_outages:    'Ukupno ispada',
        active_outages:   'Aktivni ispadi',
        resolved_outages: 'Riješeni incidenti',
        warnings:         'Upozorenja',
        filter_device:    'Pretraži uređaj, IP ili senzor...',
        filter_status:    'Status',
        filter_resolved:  'Stanje',
        all_statuses:     'Svi statusi',
        all_states:       'Sva stanja',
        active_only:      'Samo aktivni',
        resolved_only:    'Samo riješeni',
        started_at:       'Vrijeme početka',
        ended_at:         'Vrijeme oporavka',
        duration:         'Trajanje prekida',
        component:        'Komponenta / Senzor',
        reason:           'Uzrok / Poruka',
        active:           'Aktivan ispad',
        resolved:         'Riješeno',
        no_events:        'Nema zabilježenih incidenata prema odabranim filterima.',
        ongoing:          'Traje',
    },
    layout: {
        open_menu:  'Otvori izbornik',
        more:       'Više',
        close_menu: 'Zatvori izbornik',
    },
    color_mode: {
        switch_to_light: 'Prebaci na svijetlu temu',
        switch_to_dark:  'Prebaci na tamnu temu',
    },
    errors: {
        generic_error: 'Došlo je do pogreške',
        invalid_data:  'Neispravni podaci',
        not_found:     'Nije pronađeno',
        unauthorized:  'Neautoriziran pristup',
        on_add:        'Greška pri dodavanju',
        on_edit:       'Greška pri ažuriranju',
    },
    success: {
        add:  'Uspješno dodano',
        edit: 'Uspješno ažurirano',
    },
    validation: {
        required: 'Ovo polje je obavezno',
        email:    'Neispravna email adresa',
    },
    ipam: {
        title:              'IPAM & Inventar',
        subtitle:           'Središnji pregled IP adresnog prostora, automatski otkrivenih podmreža, VLAN-ova i aktivnih klijenata',
        export_csv:         'Izvezi CSV',
        refresh:            'Osvježi',
        subnets:            'Podmreže',
        active_hosts:       'Aktivni klijenti',
        free_ips:           'Slobodni IP-ovi',
        total_space:        'Ukupni prostor',
        gateways:           'Gateways',
        subnets_count:      'Podmreže ({count})',
        all:                'Sve',
        all_subnets:        'Sve podmreže',
        all_subnets_desc:   'Objedinjeni inventar svih podmreža i VLAN-ova',
        used_free:          '{used} zauzeto / {free} slobodno',
        gateway_prefix:     'GW: {ip}',
        host_table:         'Tablica hostova',
        visual_matrix:      'Vizualna matrica',
        search_placeholder: 'Pretraži IP, MAC, Proizvođača, Switch, Port...',
        filter_status:      'Status:',
        filter_all:         'Svi ({count})',
        filter_active:      'Aktivni',
        filter_gateway:     'Gateways',
        filter_switch_if:   'Switch sučelja',
        no_hosts_in_subnet: 'Nema zabilježenih klijenata u ovoj podmreži.',
        no_search_results:  'Nema IP adresa koje odgovaraju pretrazi.',
        col_ip:             'IP Adresa',
        col_mac:            'MAC Adresa',
        col_vendor:         'Proizvođač / Oprema',
        col_switch_port:    'Switch & Port',
        col_vlan:           'VLAN',
        col_status:         'Status',
        copy_ip:            'Kopiraj IP',
        inspect_mac:        'Pregledaj MAC',
        showing_hosts:      'Prikazujem {count} od {total} klijenata',
        grid_select_hint:   'Odaberi specifičnu podmrežu s lijevog panela za prikaz vizualne matrice adresa.',
        legend_active:      'Aktivan klijent',
        legend_gateway:     'Gateway / Router',
        legend_switch_if:   'Switch sučelje',
        legend_free:        'Slobodan IP',
        subnet_matrix_info: 'Podmreža: {cidr} ({used} / {total} zauzeto)',
        free_ip_desc:       'Slobodna IP adresa',
        copied_clipboard:   'Kopirano u međuspremnik',
        vlans_title:        'VLAN-ovi i Trunkovi',
        vlans_count:        'VLAN-ovi ({count})',
        filter_vlans:       'Filtriraj VLAN-ove (ID, Naziv, Subnet, Switch, Port)...',
        vlan_configured_on: 'Konfigurirano na {count} switcheva/routera',
        vlan_no_results:    'Nema pronađenih VLAN-ova prema pretrazi.',
        vlan_hosts_count:   '{count} hostova',
        vlan_ports_count:   '{count} portova',
        vlan_access_ports:  'Access portovi',
        vlan_trunk_ports:   'Trunk portovi',
        vlan_svi_ports:     'SVI / Routana sučelja',
        trunk_analyzer_title: 'Analizator trunkova i grešaka',
        trunk_matrix_title:   'Port-VLAN Matrica',
        trunk_directory_title:'Preglednik VLAN-ova',
        total_trunks:         'Ukupno trunkova',
        healthy_trunks:       'Ispravni trunkovi',
        native_mismatches:    'Native VLAN greške',
        allowed_asymmetries:  'Asimetrični allowed VLAN-ovi',
        orphan_vlans:         'Neiskorišteni VLAN-ovi',
        no_issues_detected:   'Nema detektiranih nepravilnosti na trunkovima',
        all_trunks_clean:     'Svi native VLAN-ovi i liste propuštenih VLAN-ova između switcheva su potpuno usklađeni.',
        recommended_fix:      'Preporučena CLI naredba za ispravak',
        copy_command:         'Kopiraj naredbu',
        dns_integrity_title:  'DNS Integritet',
        dns_analyzer_title:   'DNS Integritet & Analizator Mrtvih Zapisa',
        dns_analyzer_subtitle:'Dvosmjerna provjera Forward (A) i Reverse (PTR) DNS zapisa uz detekciju mrtvih/zaboravljenih zapisa',
        dns_total_analyzed:   'Ukupno Analizirano',
        dns_healthy_records:  'Ispravni Zapisi',
        dns_missing_ptr:      'Nedostaje PTR',
        dns_mismatches:       'Forward/Reverse Neslaganja',
        dns_orphan_records:   'Mrtvi (Orphan) A Zapisi',
        dns_unresolved:       'Nerazriješeni Uređaji',
        dns_resolver:         'DNS Resolver',
        dns_run_scan:         'Pokreni DNS Skeniranje',
        dns_scanning:         'Skeniranje DNS-a...',
        dns_filter_all:       'Svi Problemi',
        dns_clean_title:      'Svi DNS Zapisi Su Uredno Povezani',
        dns_clean_desc:       '100% testiranih aktivnih IPAM hostova i mrežnih uređaja ima usklađene forward i reverse DNS zapise.',
        dns_remediation:      'Preporučena DNS Sanacija',
        dns_copy_fix:         'Kopiraj DNS Naredbu',
        dhcp_scopes_title:    'DHCP Opsezi & Zakupi',
        dhcp_scopes_subtitle: 'Telemetrija DHCP opsega (MikroTik / Cisco / Managed), praćenje zakupa, nadzor iscrpljivanja adresa i IPAM korelacija',
        dhcp_total_scopes:    'Ukupno Opsega',
        dhcp_pool_capacity:   'Kapacitet Poola',
        dhcp_active_leases:   'Aktivni Zakupi',
        dhcp_free_leases:     'Dostupne IP Adrese',
        dhcp_pools_at_risk:   'Ugroženi Opsezi (>85%)',
        dhcp_avg_utilization: 'Prosječna Iskorištenost',
        dhcp_sync_now:        'Sinkroniziraj DHCP Telemetriju',
        dhcp_syncing:         'Sinkronizacija...',
        dhcp_add_scope:       'Dodaj DHCP Opseg',
        dhcp_tab_scopes:      'Adresni Poolovi (Opsezi)',
        dhcp_tab_leases:      'Aktivni Zakupi (Leases)',
        dhcp_col_scope_name:  'Naziv Opsega',
        dhcp_col_subnet:      'Podmreža / Raspon',
        dhcp_col_server:      'DHCP Poslužitelj',
        dhcp_col_utilization: 'Iskorištenost',
        dhcp_col_leases:      'Aktivno / Ukupno',
        dhcp_col_lease_time:  'Trajanje Zakupa',
        dhcp_col_status:      'Status',
        dhcp_col_actions:     'Radnje',
        dhcp_col_expires:     'Istječe Za',
        dhcp_col_client_type: 'Vrsta',
        dhcp_badge_scope:     'DHCP Opseg',
        dhcp_badge_lease:     'DHCP Zakup',
        dhcp_filter_scopes:   'Filtriraj opsege (naziv, CIDR, server)...',
        dhcp_filter_leases:   'Filtriraj zakupe (IP, MAC, proizvođač, host)...',
        dhcp_delete_confirm:  'Jeste li sigurni da želite obrisati ovaj DHCP opseg?',
        dhcp_modal_create_title: 'Kreiraj DHCP Opseg',
        dhcp_modal_create_desc:  'Definirajte DHCP adresni raspon za telemetrijsko praćenje i IPAM korelaciju.',
    },
    security: {
        title:              'Sigurnost Portova & Detekcija Rogue Uređaja',
        subtitle:           'MAC whitelisting u realnom vremenu, detekcija neovlaštenih uređaja i nadzor switch portova',
        scan_now:           'Skeniraj mrežu odmah',
        auto_baseline:      'Automatski baseline (snimi stanje)',
        add_rule:           'Dodaj MAC pravilo',
        refresh:            'Osvježi',
        total_whitelisted:  'Odobrene MAC adrese',
        active_alerts:      'Aktivni Rogue alarmi',
        port_violations:    'Povrede portova',
        randomized_macs:    'Privatne / Random MAC adrese',
        tab_alerts:         'Sigurnosni Alarmi',
        tab_whitelist:      'Bijela lista (MAC Whitelist)',
        filter_all:         'Svi',
        filter_active:      'Aktivni',
        filter_acknowledged:'Potvrđeni',
        filter_resolved:    'Riješeni',
        search_alerts:      'Pretraži alarme po MAC, IP, switchu, portu...',
        search_whitelist:   'Pretraži bijelu listu po MAC, imenu, portu...',
        col_severity:       'Razina',
        col_mac:            'MAC Adresa',
        col_device_name:    'Uređaj / Hostname',
        col_vendor:         'Proizvođač / OUI',
        col_switch_port:    'Switch & Port',
        col_vlan:           'VLAN',
        col_type:           'Tip alarma',
        col_occurrences:    'Ponavljanja',
        col_last_seen:      'Zadnje viđen',
        col_status:         'Status',
        col_actions:        'Akcije',
        col_expected_port:  'Dozvoljeni port',
        col_expected_ip:    'Dozvoljeni IP',
        btn_whitelist_now:  'Dodaj u listu',
        btn_acknowledge:    'Potvrdi',
        btn_resolve:        'Riješi',
        btn_edit:           'Uredi',
        btn_delete:         'Obriši',
        type_rogue_device:  'Nepoznati uređaj (Rogue)',
        type_port_mismatch: 'Premješten port',
        type_ip_spoofing:   'IP konflikt / Spoofing',
        type_randomized_mac:'Randomizirani MAC',
        status_whitelisted: 'Odobren',
        status_trusted:     'Pouzdano',
        status_blocked:     'Blokiran',
        status_flagged:     'Označeno',
        badge_randomized:   'Privatni / Random MAC',
        no_alerts_found:    'Nema zabilježenih sigurnosnih alarma. Mreža je sigurna.',
        no_whitelist_found: 'Nema unosa u bijeloj listi. Pokrenite Automatski baseline za uvoz aktivnih uređaja.',
        modal_add_title:    'Dodavanje uređaja na bijelu listu',
        modal_edit_title:   'Uređivanje MAC pravila',
        field_mac:          'MAC Adresa (npr. 00:11:22:33:44:55)',
        field_name:         'Naziv uređaja / Opis',
        field_vendor:       'Proizvođač (Opcionalno)',
        field_switch:       'Dozvoljeni switch',
        field_port:         'Dozvoljeni port (npr. Gi0/1 - prazno za bilo koji)',
        field_ip:           'Dozvoljeni IP (Opcionalno)',
        field_vlan:         'VLAN (Opcionalno)',
        field_status:       'Sigurnosni status',
        field_comment:      'Napomena',
        scan_started:       'Skeniranje switcheva u tijeku...',
        scan_completed:     'Skeniranje dovršeno: pregledano {scanned} switcheva, analizirano {found} MAC adresa, otkriveno {rogues} novih nepoznatih uređaja.',
        baseline_confirm:   'Jeste li sigurni da želite automatski snimiti baseline? Svi trenutno spojeni uređaji bit će dodani na bijelu listu i vezani za svoje switch portove.',
        baseline_success:   'Uspješno spremljeno {count} uređaja na bijelu listu.',
        delete_confirm:     'Jeste li sigurni da želite ukloniti ovaj MAC s bijele liste?',
        action_success:     'Akcija uspješno izvršena',
    },
    syslog: {
        title:               'Centralni Syslog & SNMP Trap Receiver',
        subtitle:            'Prihvat UDP 514 Syslog poruka i UDP 162 SNMP Trapova u realnom vremenu, parsiranje Cisco mnemonika i trenutni alarmi',
        live_Pause:          'Prijenos uživo aktivan',
        paused:              'Prijenos pauziran',
        simulate:            'Simuliraj događaj / Trap',
        clear_old:           'Očisti stare zapise',
        total_messages:      'Ukupno pohranjenih poruka',
        last_24h:            'Događaji (Zadnjih 24h)',
        critical_24h:        'Kritično / Alarmi (24h)',
        warnings_24h:        'Upozorenja (24h)',
        syslog_vs_trap:      'Syslog vs SNMP Trapovi',
        top_categories:      'Najčešće kategorije:',
        search_placeholder:  'Pretraži poruku, mnemonik (%LINK-3-UPDOWN), IP, uređaj, sučelje...',
        all_protocols:       'Svi protokoli',
        all_devices:         'Svi uređaji',
        all_categories:      'Sve kategorije',
        all_severities:      'Sve razine (Severity)',
        Critical_only:       'Samo kritično i greške (Sev 0-3)',
        warnings_and_up:     'Upozorenja i više (Sev 0-4)',
        notifications_and_up:'Obavijesti (Notice) i više (Sev 0-5)',
        info_and_up:         'Informacije i više (Sev 0-6)',
        col_time:            'Vrijeme',
        col_protocol:        'Protokol',
        col_severity:        'Razina',
        col_device:          'Izvorni uređaj',
        col_category:        'Kategorija',
        col_mnemonic:        'Mnemonik / Trap OID',
        col_message:         'Sadržaj poruke',
        no_messages:         'Nema Syslog ili SNMP Trap poruka prema odabranim kriterijima.',
        no_messages_hint:    'Usmjerite routere/switcheve na UDP port 514 (Syslog) ili UDP port 162 (SNMP Trap), ili kliknite "Simuliraj događaj / Trap" za test.',
        showing_count:       'Prikazano {shown} od {total} poruka',
        simulate_desc:       'Ubacite realistični Syslog paket ili SNMP Trap PDU u prijemnik za provjeru parsiranja, kategorizacije i trenutnog alarmiranja.',
        preset_template:     'Predložak događaja',
        protocol:            'Protokol',
        source_device:       'Izvorni uređaj',
        custom_ip:           'Vlastita / Vanjska IP adresa',
        source_ip:           'Izvorna IP adresa',
        hostname:            'Hostname',
        severity:            'Razina ozbiljnosti (Severity)',
        category:            'Kategorija događaja',
        mnemonic:            'Cisco Mnemonik / Identifikator',
        interface_opt:       'Sučelje (Opcionalno)',
        message_body:        'Tekst Syslog poruke / Sažetak Trapa',
        send_simulation:     'Pošalji simulirani događaj',
        sim_sent_title:      'Događaj zaprimljen',
        sim_sent_desc:       'Simulirana Syslog/Trap poruka je obrađena i pohranjena.',
        cleared_title:       'Zapisi očišćeni',
        cleared_desc:        'Uklonjeno {count} starih zapisa.',
        detail_title:        'Inspekcija događaja i paketa',
        trap_oid:            'SNMP Trap OID',
        raw_payload:         'Izvorni paket (Raw Payload / VarBinds)',
    },
    topology: {
        title:               'Topologija mreže',
        subtitle:            'Automatski generirana L2/L3 topologija mreže i prikaz spajanja po portovima na temelju CDP, LLDP i SNMP telemetrije',
        nodes_count:         '{count} čvorova',
        links_count:         '{count} aktivnih veza',
        ports_count:         '{count} spojenih portova',
        view_mode:           'Prikaz mape:',
        view_wiring:         'Shema: Switch → MAC → Uređaj',
        view_chassis:        'Fizički prikaz switcha (Faceplate)',
        view_ports:          'Mapa Switcheva i Portova',
        view_graph:          'Interaktivni Graf Mreže',
        view_matrix:         'Tablica Spajanja (Patch Matrix)',
        filter_all:          'Sve',
        filter_switches:     'Switchevi',
        filter_routers:      'Routeri',
        filter_managed:      'Nadzirani',
        search_placeholder:  'Filtriraj čvorove, portove, opise ili IP...',
        reset_layout:        'Resetiraj prikaz',
        refresh_scan:        'Osvježi topologiju',
        scanning:            'Skeniram CDP/LLDP susjede i telemetriju portova...',
        legend_title:        'Legenda topologije',
        legend_monitored:    'Nadzirani uređaj (SNMP UP)',
        legend_external:     'CDP/LLDP susjed',
        legend_offline:      'Upozorenje / Offline',
        status_label:        'Status čvora',
        status_monitored:    'Nadzirani uređaj',
        status_external:     'Otkriveni susjed (CDP/LLDP)',
        type_label:          'Vrsta opreme',
        vendor_model:        'Proizvođač & Model',
        open_in_devices:     'Otvori u uređajima',
        connected_links:     'Povezani linkovi i portovi ({count})',
        local_port:          'Lokalni port',
        remote_port:          'Udaljeni port',
        port_alias:          'Opis porta / Alias',
        connected_device:    'Spojeni uređaj / Susjed',
        protocol:            'Protokol',
        speed_traffic:       'Brzina & Promet uživo',
        switch_chassis_desc: 'Aktivni fizički i LAG portovi s CDP/LLDP susjedima i SNMP opisima sučelja',
        show_all_ports:      'Prikaži sve aktivne označene portove',
        show_cdp_only:       'Samo CDP / LLDP veze',
        no_links_found:      'Nema pronađenih veza prema odabranom filteru.',
        unidentified_peer:   'Aktivan link (Bez CDP/Opisa)',
        external_peers:      'Otkrivena spojena oprema i krajnji uređaji',
    },
    doc: {
        title:                'Mrežna Dokumentacija (HLD & LLD)',
        subtitle:             'Cjelovita arhitekturna i tehnička specifikacija mreže generirana uživo iz SNMP telemetrije',
        tab_hld:              'High-Level Design (HLD)',
        tab_lld:              'Low-Level Design (LLD)',
        export_pdf:           'Ispiši / Spremi PDF',
        export_md:            'Preuzmi Markdown',
        export_csv:           'Izvezi CSV',
        refresh:              'Osvježi podatke',
        generated_at:         'Generirano:',
        summary_devices:      'Ukupno uređaja',
        summary_online:       'Online uređaja',
        summary_ports:        'Fizičkih portova',
        summary_active_ports: 'Aktivnih portova',
        summary_subnets:      'IPAM podmreža',
        summary_hosts:        'Aktivnih hostova',
        layers_title:         'Arhitektura slojeva mreže',
        layers_desc:          'Hijerarhijska podjela mrežne opreme (Core, Spine, Leaf, Access, WAN)',
        ipam_title:           'Globalni IPAM adresni plan (/24 i cjepani subneti)',
        routing_title:        'Routing & Overlay protokoli (BGP EVPN, OSPF, VXLAN)',
        diagram_title:        'Arhitekturni dijagram topologije',
        hardware_title:       'Hardverski inventar (BOM - Bill of Materials)',
        hardware_desc:        'Šasije, točni modeli, serijski brojevi, verzije firmvera, napajanja i ventilatori',
        patch_title:          'Kompletna Port & Patch matrica',
        patch_desc:           'Pregled svih fizičkih i logičkih sučelja, brzina, VLAN-ova i susjednih veza',
        optics_title:         'Optički SFP budžet i razine signala',
        optics_desc:          'Telemetrija optičkih primopredajnika (Rx/Tx snaga, jačina lasera)',
        search_placeholder:   'Pretraži tablicu...',
        filter_all:           'Svi slojevi',
        all_status:           'Svi statusi',
        device:               'Uređaj',
        ip_address:           'IP Adresa',
        model:                'Model',
        vendor:               'Proizvođač',
        serial:               'Serijski broj',
        os_version:           'Verzija OS-a',
        uptime:               'Uptime',
        status:               'Status',
        psu1:                 'PSU 1',
        psu2:                 'PSU 2',
        fans:                 'Ventilatori',
        temp:                 'Temp',
        cpu_ram:              'CPU / RAM',
        port:                 'Port',
        alias:                'Opis porta (Alias)',
        vlan:                 'VLAN',
        speed:                'Brzina',
        duplex:               'Duplex',
        remote_device:        'Spojeni susjed',
        remote_port:          'Udaljeni port',
        protocol:             'Protokol',
        tx_power:             'Tx Snaga',
        rx_power:             'Rx Snaga',
        bias_current:         'Laser Bias',
        signal_health:        'Stanje signala',
        bgp_peers:            'BGP Sesije & Peering',
        ospf_neighbors:       'OSPF Susjedstva',
        vxlan_vnis:           'EVPN VXLAN VNI & Tuneli',
        peer_ip:              'Peer IP',
        remote_as:            'Remote AS',
        bgp_state:            'Stanje sesije',
        neighbor_id:          'Susjed ID',
        router_id:            'Router ID',
        ospf_state:           'Stanje OSPF',
        vni_id:               'VNI ID',
        vlan_id:              'VLAN ID',
        nve_if:               'NVE Sučelje',
        vni_state:            'VNI Status',
        copied_clipboard:     'Kopirano u međuspremnik!',
    },
    sensor_action: {
        ack_title:           'Potvrda alarma senzora (ACK)',
        ack_title_edit:      'Uredi potvrdu alarma (ACK)',
        pause_title:         'Pauziraj ispitivanje senzora',
        resume_title:        'Nastavi ispitivanje senzora',
        recorded_operator:   'Zabilježeni operater',
        logged_in:           'Prijavljen',
        comment_label_ack:   'Komentar / razlog potvrde',
        comment_label_pause: 'Razlog pauziranja / održavanja',
        visible_to_team:     'Vidljivo cijelom timu',
        comment_ph_ack:      'npr. Radovi na linku u tijeku, ISP prijavio prekid, zamjena opreme...',
        comment_ph_pause:    'npr. Planirano održavanje opreme, privremeno isključeno radi testiranja...',
        btn_clear_ack:       'Ukloni ACK',
        btn_ack:             'Potvrdi senzor (ACK)',
        btn_update_comment:  'Spremi komentar',
        btn_pause:           'Pauziraj ispitivanje',
        btn_resume:          'Nastavi ispitivanje',
        btn_resume_now:      'Nastavi sada',
        btn_acked:           'Potvrđeno',
        acked_by:            'Potvrdio',
        paused_by:           'Pauzirao',
        no_comment:          'Nema napomene',
        banner_acked:        'Alarm senzora je potvrđen',
        banner_paused:       'Ispitivanje senzora je pauzirano',
        edit_comment:        'Uredi komentar',
        clear_ack:           'Ukloni ACK',
        success_ack:         'Alarm senzora je potvrđen',
        success_unack:       'Potvrda alarma senzora je uklonjena',
        success_pause:       'Ispitivanje senzora je pauzirano',
        success_resume:      'Ispitivanje senzora je nastavljeno',
        presets: {
            maintenance:       'Radovi na mreži u tijeku',
            isp_outage:        'ISP prekid - prijavljen kvar',
            hardware_replace:  'Čeka se zamjena SFP-a / opreme',
            known_issue:       'Poznati problem - rješavanje u tijeku',
            investigating:     'Privremeni prekid - prati se stanje',
            pause_maintenance: 'Planirano održavanje opreme',
            pause_testing:     'Privremeno isključeno radi testiranja',
            pause_disabled:    'Uređaj van funkcije do daljnjega',
            pause_customer:    'Korisnički priključak ugašen',
            pause_monitoring:  'Pauzirano nadgledanje',
        },
    },
    inspector: {
        title_up:           'Ispravni senzori i uređaji (UP)',
        title_down:         'Kritični senzori i prekidi (DOWN)',
        title_warning:      'Upozorenja i degradirani senzori (WARN)',
        title_ack:          'Potvrđeni senzori (ACK)',
        title_paused:       'Pauzirani senzori / Održavanje (PAUSED)',
        title_unknown:      'Nepoznati / Neispitani senzori (UNKNOWN)',
        subtitle:           'Detaljni opisi senzora, telemetrijska očitanja, potvrde (ACK) i razlozi pauziranja.',
        matching:           'odgovara',
        close_filter:       'Zatvori filter',
        search_placeholder: 'Pretraži senzor, uređaj, komentar ili korisnika...',
        no_matching:        'Trenutno nema senzora ili uređaja sa statusom',
        th_status:          'Status',
        th_device:          'Uređaj',
        th_sensor_name:     'Naziv senzora / čvora',
        th_type:            'Tip',
        th_detail:          'Opis senzora & ACK / Pause detalji',
        th_reading:         'Trenutno očitanje',
        th_last_checked:    'Zadnja provjera',
        th_actions:         'Radnje',
        inspect:            'Pregledaj',
        clone_sensor:       'Kloniraj senzor',
        showing:            'Prikazano',
        of:                 'od',
        specs_title:        'Konfiguracija senzora i pragovi',
        sensor_id:          'ID senzora',
        check_interval:     'Interval provjere',
        alarm_thresholds:   'Pragovi alarma',
        edit_thresholds:    'Uredi pragove / senzor',
    },
    bgp: {
        session_uptime:        'Uptime sesije',
        remote_as:             'Udaljeni AS / Peer',
        asn_lookup_title:      'Pregled autonomnog sustava (ASN)',
        asn_lookup_btn:        'AS Pregled',
        asn_input_placeholder: 'Unesite AS broj (npr. 13335, AS5448, 65400)...',
        quick_presets:         'Brzi odabir:',
        querying_whois:        'Dohvaćanje WHOIS i RIPE Stat zapisa...',
        private_as:            'Privatni AS',
        public_as:             'Javni AS',
        network_type:          'Tip mreže',
        description:           'Opis',
        external_tools:        'Vanjski BGP alati i Looking Glass',
        lookup_as:             'Provjeri AS',
        enter_valid_as:        'Molimo unesite valjani AS broj',
        asn_not_found:         'Informacije o AS broju nisu pronađene',
        network_error:         'Greška u komunikaciji prilikom dohvata AS broja',
        resolving:             'Dohvaćam...',
        established:           'Uspostavljeno',
    },
    scanner: {
        port_scan_title:      'Skeniranje portova & Servisi',
        port_scan_hint:       'Automatski otkriva otvorene servise (SSH, HTTP, DNS, Winbox, BGP) i stvara grupu senzora',
        profile:              'Profil skeniranja',
        profile_well_known:   'Standardni servisi (~75 portova, <1s)',
        profile_common_1024:  'Standardni portovi 1-1024 (~1s)',
        profile_top_1000:     'Top 1000 portova (~2s)',
        scan_now:             'Skeniraj odmah',
        enter_ip_first:       'Unesite IP adresu uređaja prije skeniranja',
        scan_failed:          'Skeniranje portova nije uspjelo',
        found_ports:          'Pronađeno {count} otvorenih portova ({duration} ms)',
        no_open_ports:        'Nema otvorenih portova',
        open_ports_tab:       'Otvoreni portovi & Servisi',
        open_ports_title:     'Otvoreni portovi & Mrežni servisi',
        rescan_now:           'Skeniraj portove',
        add_all_as_sensors:   'Dodaj sve kao senzore',
        open_ports_count:     'Otvoreni portovi',
        scan_speed:           'Brzina skeniranja',
        target_ip:            'Ciljna IP adresa',
        active_sensors:       'Aktivni senzori portova',
        search_placeholder:   'Pretraži po portu, protokolu ili servisu (npr. 80, SSH, HTTP)...',
        empty_hint:           'Nema zabilježenih otvorenih portova za ovaj uređaj. Pokrenite brzo višenitno skeniranje.',
        start_scan:           'Pokreni skeniranje portova',
        col_port:             'Port / Protokol',
        col_service:          'Servis',
        col_description:      'Opis servisa',
        col_latency:          'Odziv',
        col_version:          'Verzija softvera',
        col_banner:           'Banner / Zaglavlje',
        dns_hostname:         'DNS ime (PTR)',
        detected_os:          'Prepoznati OS / Platforma',
        resolving_dns:        'Dohvaćam DNS...',
        apply_dns_name:       'Postavi kao naziv čvora',
        col_status:           'Status',
        col_action:           'Senzor u stablu',
        sensor_active:        'Senzor aktivan',
        create_sensor:        'Dodaj senzor',
        scan_completed:       'Pronađeno {count} otvorenih portova u {duration}ms',
    },
    proxmox: {
        loading:              'Učitavanje Proxmox VE telemetrije i virtualnih instanci...',
        connect_error_title:  'Greška pri spajanju na Proxmox VE API',
        retry:                'Pokušaj ponovno',
        connected_token:      'Povezano (API Token)',
        refresh:              'Osvježi telemetriju',
        sync_sensors:         'Sinkroniziraj senzore',
        node_memory:          'Node memorija',
        storage_kpi:          'Skladišta (Pools)',
        stopped_count:        '{count} Ugašeno',
        lxc_containers:       'LXC kontejneri',
        storage_title:        'Diskovna skladišta (Storage Pools)',
        active_pools:         '{count} aktivnih poolova',
        utilization:          'Iskorištenost',
        used:                 'Zauzeto: {value}',
        total:                'Ukupno: {value}',
        guests_title:         'Virtualne instance (VM & LXC)',
        instances_count:      '{count} instanci',
        filter_all:           'Sve',
        filter_all_types:     'Svi tipovi',
        search_placeholder:   'Traži po nazivu ili VMID-u...',
        col_name:             'Naziv instance',
        col_type:             'Tip',
        no_guests:            'Nema pronađenih virtualnih mašina ili kontejnera za odabrane filtre.',
        fetch_failed:         'Neuspjelo dohvaćanje Proxmox telemetrije',
        api_unavailable:      'Proxmox API nije dostupan',
        server_error:         'Greška pri komunikaciji s poslužiteljem',
        sync_failed:          'Neuspjela sinkronizacija Proxmox senzora: {error}',
        sync_success:         'Proxmox senzori i virtualne instance uspješno sinkronizirani!',
        sync_error:           'Greška pri sinkronizaciji: {error}',
        unknown_error:        'Nepoznata greška',
        integration_title:    'Proxmox VE integracija',
        integration_hint:     'Nadzor PVE čvora, storage poolova, QEMU VM-ova i LXC kontejnera putem HTTPS API-ja (port 8006)',
        ignore_ssl:           'Zanemari samopotpisani SSL certifikat',
        token_id_placeholder: "npr. monitoring{'@'}pve!nervuseye",
        test_connection:      'Testiraj Proxmox API vezu',
        connected:            'Povezano s Proxmox VE!',
        connect_failed:       'Neuspjelo povezivanje s Proxmox VE',
        test_failed:          'Neuspješno testiranje API veze',
        col_ip:               'IP Adresa',
        col_agent:            'QEMU Agent',
        agent_active:         'Agent Aktivan',
        agent_stopped:        'Agent Ne radi',
        agent_not_installed:  'Nema Agenta',
        agent_lxc:            'LXC Izvorno',
        ip_copied:            'IP adresa kopirana',
        no_ip:                'Nema IP-a',
        ram_allocated:        'RAM (Memorija)',
        disk_allocated:       'Disk (Pohrana)',
        filesystems:          'Datotečni sustavi (Mounts)',
        os_info:              'Operacijski sustav',
        copy_ip:              'Klikni za kopiranje IP-a',
    },
    hyperv: {
        loading:              'Učitavanje Hyper-V telemetrije i virtualnih mašina...',
        connect_error_title:  'Neuspješno spajanje na Hyper-V poslužitelj putem WinRM-a',
        retry:                'Pokušaj ponovno',
        connected_winrm:      'Spojeno (WinRM PowerShell)',
        refresh:              'Osvježi telemetriju',
        sync_sensors:         'Sinkroniziraj senzore',
        host_memory:          'Radna memorija hosta',
        logical_processors:   'Logički procesori',
        switches_title:       'Virtualni switchevi',
        vms_title:            'Virtualne mašine (Hyper-V)',
        vms_count:            '{count} VM-ova',
        filter_all:           'Sve',
        filter_running:       'Pokrenute (Running)',
        filter_stopped:       'Zaustavljene / Spremljene',
        search_placeholder:   'Pretraži VM po nazivu, IP-u ili switchu...',
        col_name:             'Naziv VM-a',
        col_state:            'Stanje',
        col_vcpu:             'vCPU & Opterećenje',
        col_memory:           'Memorija (Potražnja / Dodijeljeno)',
        col_network:          'Mreža (IP / MAC / Switch)',
        col_disks:            'Virtualni diskovi (VHD)',
        col_uptime:           'Vrijeme rada',
        no_vms:               'Nema virtualnih mašina koje odgovaraju odabranom filteru.',
        sync_success:         'Hyper-V senzori za host i VM-ove uspješno sinkronizirani!',
        sync_failed:          'Greška pri sinkronizaciji Hyper-V senzora: {error}',
        integration_title:    'Microsoft Hyper-V integracija',
        integration_hint:     'Nadzor Hyper-V poslužitelja, virtualnih switcheva i VM-ova putem WinRM protokola (port 5985/5986)',
        port_label:           'WinRM Port',
        username_label:       'Korisničko ime (lokalni ili domenski račun)',
        password_label:       'Lozinka',
        use_https:            'Koristi HTTPS WinRM (port 5986)',
        ignore_ssl:           'Zanemari greške SSL certifikata',
        test_connection:      'Testiraj WinRM vezu',
        connected:            'Uspješno spojen na Hyper-V host!',
        connect_failed:       'Neuspješno spajanje na Hyper-V host',
    },
    tools: {
        page_title:              'Mrežni & Sustavni Alati i Dijagnostika',
        page_subtitle:           'Napredni mrežni dijagnostički alati, provjere domenske sigurnosti (SPF, DKIM, DMARC) te BGP i RPKI / ROA usmjeravanje',
        category_network:        'Mrežni alati',
        category_security:       'Sigurnost domena i pošte',
        category_bgp:            'BGP & RPKI Usmjeravanje',
        target_host:             'Ciljni host / IP adresa',
        packet_count:            'Broj paketa',
        run_ping:                'Pokreni ICMP Ping',
        pinging:                 'Slanje ping paketa...',
        ping_title:              'Aktivni ICMP / TCP Ping',
        ping_subtitle:           'Analiza gubitka paketa, kašnjenja (RTT), jittera i TTL parametara',
        execution_failed:        'Izvođenje dijagnostike nije uspjelo',
        resolved_ip:             'Razriješeni IP',
        packets:                 'Paketi (Primljeno/Poslano)',
        packet_loss:             'Gubitak paketa',
        min_rtt:                 'Min RTT',
        avg_rtt:                 'Prosječni RTT',
        max_rtt:                 'Maks RTT',
        icmp_packets_sequence:   'Slijed ICMP paketa',
        total_time:              'Ukupno vrijeme: {ms} ms',
        traceroute_title:        'Traceroute & MTR Analizator rute',
        traceroute_subtitle:     'Skok-po-skok kašnjenje, obrnuto DNS (PTR) razrješavanje i provjera autonomnog sustava (ASN)',
        max_hops:                'Maksimalno skokova',
        run_traceroute:          'Pokreni Traceroute',
        tracing:                 'Praćenje rute...',
        destination_reached:     'Cilj dosegnut',
        incomplete_trace:        'Nepotpuna ruta',
        total_hops:              'Pređeno {count} skokova',
        dns_title:               'DNS Upiti & Dig Inspekcija',
        dns_subtitle:            'Izravni upiti za A, AAAA, CNAME, MX, TXT, NS, PTR, SOA i SRV zapise s odabirom poslužitelja',
        domain_or_ip:            'Naziv domene ili IP',
        record_type:             'Vrsta zapisa',
        dns_server:              'DNS poslužitelj',
        query_dns:               'Pošalji upit',
        resolving:               'Upit prema poslužitelju...',
        dns_query_failed:        'DNS upit nije uspio',
        server_used:             'Korišteni poslužitelj',
        response_time:           'Vrijeme odziva',
        records_returned:        'Vraćeno zapisa',
        no_records_found:        'Nema pronađenih DNS zapisa za navedeni upit i tip zapisa.',
        port_scanner_title:      'Port skener & TCP servisna provjera',
        port_scanner_subtitle:   'Provjera dostupnosti mrežnih portova, mjerenje latencije i dohvat servisnih natpisa (banner)',
        port_preset:             'Predlošci portova',
        custom_port_spec:        'Definicija portova (zarezom odvojeno ili raspon)',
        scan_ports:              'Skeniraj portove',
        scanning_ports:          'Skeniranje portova...',
        scan_failed:             'Skeniranje portova nije uspjelo',
        target_ip:               'Ciljani IP',
        scanned_ports:           'Skenirano portova',
        open_ports:              'Otvoreno portova',
        duration:                'Trajanje skeniranja',
        whois_title:             'WHOIS Imenik domena i IP adresa',
        whois_subtitle:          'Registrar, vlasništvo, vremenska crta registracije i provjera autoritativnih poslužitelja',
        lookup_whois:            'Provjeri WHOIS',
        looking_up:              'Dohvat WHOIS podataka...',
        whois_failed:            'WHOIS upit nije uspio',
        subnet_calc_title:       'Kalkulator podmreža & CIDR maske',
        subnet_calc_subtitle:    'Matematika CIDR prefiksa, raspon iskoristivih hostova, wildcard i binarna alokacija',
        ip_or_cidr:              'IP adresa ili CIDR',
        subnet_mask:             'Maska podmreže',
        spf_title:               'SPF Analizator zapisa & Simulator pošiljatelja',
        spf_subtitle:            'RFC 7208 provjera sintakse, limit od 10 DNS upita i provjera autorizacije IP pošiljatelja',
        domain:                  'Naziv domene',
        test_sender_ip:          'Testiraj IP pošiljatelja (opcionalno)',
        check_spf:               'Provjeri SPF',
        checking:                'Provjera pravila...',
        spf_failed:              'SPF provjera nije uspjela',
        dkim_title:              'DKIM Javni ključ & Selektor validacija',
        dkim_subtitle:           'Validacija DKIM DNS zapisa, kriptografskih javnih ključeva i upozorenje na slabe 1024-bit RSA ključeve',
        check_dkim:              'Provjeri DKIM',
        dmarc_title:             'DMARC Pravila & Inspekcija zaštite',
        dmarc_subtitle:          'Evaluacija DMARC zaštite od lažiranja (spoofing), agregatnih izvještaja (RUA) i sigurnosna ocjena',
        check_dmarc:             'Provjeri DMARC',
        smtp_title:              'SMTP & MX Poslužitelji pošte dijagnostika',
        smtp_subtitle:           'Provjera poslužitelja za isporuku, spajanje na port 25, banner i podrška za STARTTLS enkripciju',
        test_smtp:               'Testiraj SMTP',
        testing:                 'Testiranje veze...',
        tls_cert_title:          'SSL / TLS Certifikat Inspekcija',
        tls_cert_subtitle:       'Provjera isteka certifikata, alternativnih imena (SAN), izdavača i TLS enkripcijskih paketa',
        inspect_cert:            'Pregledaj certifikat',
        inspecting:              'Inspekcija TLS rukovanja...',
        bgp_lookup_title:        'BGP Ruta, Prefiks & RPKI Provjera',
        bgp_lookup_subtitle:     'Oglašeni prefiks, izvorišni AS, kriptografska RPKI ROA validacija i IRR route objekti',
        ip_or_prefix:            'IP adresa ili CIDR prefiks',
        lookup_route:            'Provjeri BGP rutu',
        querying_bgp:            'Dohvat globalnog BGP usmjeravanja...',
        lookup_failed:           'BGP upit nije uspio',
        asn_explorer_title:      'Preglednik autonomnih sustava (ASN)',
        asn_explorer_subtitle:   'Operater mreže, veličina IPv4 & IPv6 tablice usmjeravanja te tranzitni partneri',
        asn_number:              'AS Broj (npr. AS15169)',
        lookup_asn:              'Pretraži ASN',
        rpki_validator_title:    'RPKI Kriptografski ROA Validator',
        rpki_validator_subtitle: 'Provjerava je li izvorišni autonomni sustav kriptografski ovlašten oglašavati navedeni prefiks',
        prefix:                  'CIDR Prefiks',
        validate_rpki:           'Validiraj RPKI ROA',
        validating:              'Validacija kriptografskog ROA zapisa...',
        bgp_looking_glass_title:    'Javni preglednici usmjerivača & BGP putanje (Looking Glass)',
        bgp_looking_glass_subtitle: 'BGP putanje u stvarnom vremenu preko RouteViews, Twelve99 / Arelion, Cogent i RIPE RIS kolektora',
        query_paths:                'Dohvati BGP putanje uživo',
        querying_paths:             'Prikupljanje BGP putanja u stvarnom vremenu...',
        filter_all:                 'Svi preglednici',
        filter_twelve99:            'Twelve99 (Arelion AS1299)',
        filter_cogent:              'Cogent (AS174)',
        filter_tier1:               'Tier-1 tranzitne okosnice',
        filter_routeviews:          'RouteViews kolektori',
        filter_ripe:                'RIPE RIS kolektori',
        external_viewers:           'Javni Looking Glass preglednici & izravan pristup',
        as_path_flow:               'Tijek AS putanje',
        collector_location:         'Kolektor & lokacija',
        peer_router:                'Partnerski usmjerivač',
        communities:                'BGP zajednice (Communities)',
    },
}
